@use '@design/design-tokens/typography/typography' as *;

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.proportionChangeContainer {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.dateSpan {
  text-align: end;
  color: var(--text-soft);
}

.priceRow {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.proportionPrice {
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--text-default);
}

.proportionCurrency {
  @include typography-v2-body-xxs;
  color: var(--text-default);
  text-transform: uppercase;
}

.percentageChange {
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;

  &.positive {
    color: var(--viz-bullish);
  }

  &.negative {
    color: var(--viz-bearish);
  }

  &.default {
    color: var(--text-soft);
  }
}
